import { render, staticRenderFns } from "./p3.vue?vue&type=template&id=c4e6023a&"
import script from "./p3.vue?vue&type=script&lang=js&"
export * from "./p3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports